import { apiSlice } from "./apiSlice";
import { apiRoutes } from "../../config/api";
import { downloadBinaryBlob } from "../../utils";

/** Query params for GET /inventory/summary may include groupBy, e.g. sku,site,zone (backend-dependent). */
export const inventoryService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInventorySummary: builder.query({
      query: (params: Record<string, unknown>) => ({
        url: apiRoutes.INVENTORY_SUMMARY,
        params,
        method: "GET",
      }),
    }),
    getInventoryDetails: builder.query({
      query: (params: Record<string, unknown>) => ({
        url: apiRoutes.INVENTORY_DETAILS,
        params,
        method: "GET",
      }),
    }),

    exportLiveInventoryExcel: builder.mutation<boolean, Record<string, any>>({
      async queryFn(params, _api, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: apiRoutes.LIVE_INVENTORY_EXPORT,
          method: "GET",
          params,
          responseHandler: async (response: Response) => await response.blob(),
        });

        if (result.error) {
          return { error: result.error };
        }

        const blob = result.data as Blob;

        const now = new Date();

        const formattedDate = `${String(now.getMonth() + 1).padStart(2, "0")}-${String(
          now.getDate(),
        ).padStart(2, "0")}-${now.getFullYear()}`;

        downloadBinaryBlob(blob, `inventory-summary-${formattedDate}.xlsx`);

        return { data: true };
      },
    }),
  }),
});

export const { useGetInventorySummaryQuery, useGetInventoryDetailsQuery, useExportLiveInventoryExcelMutation } =
  inventoryService;
